// extracted by mini-css-extract-plugin
export var container = "_10-0";
export var disabled = "_10-4";
export var fullWidth = "_10-3";
export var lined = "_10-1";
export var selected = "_10-5";
export var tab = "_10-2";